import * as types from "./types";

export const EMPTY_HEATMAP_COUNTS = {
  supervisors: 0,
  organizers: 0,
  offline: 0,
  total: 0,
};

const initialState = {
  data: [],
  counts: EMPTY_HEATMAP_COUNTS,
  loading: false,
  error: null,
};

const heatmapReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_HEATMAP_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_HEATMAP_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload.data,
        counts: action.payload.counts,
      };
    case types.FETCH_HEATMAP_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        data: [],
        counts: EMPTY_HEATMAP_COUNTS,
      };
    default:
      return state;
  }
};

export default heatmapReducer;
